import * as React from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-[11px] font-medium leading-5',
  {
    variants: {
      variant: {
        default: 'border-border bg-muted text-muted-foreground',
        accent: 'border-primary/30 bg-primary/15 text-foreground',
        success: 'border-emerald-200 bg-emerald-500/10 text-emerald-700',
        warning: 'border-amber-200 bg-amber-500/12 text-amber-700',
        destructive: 'border-rose-200 bg-rose-500/10 text-rose-700',
        outline: 'border-border bg-transparent text-foreground',
        secondary: 'border-border bg-secondary text-secondary-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

function Badge({ className, variant, ...props }) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
